import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconOpenAi12 from './IconOpenAi12';
import IconOpenAi16 from './IconOpenAi16';
import IconOpenAi20 from './IconOpenAi20';
import IconOpenAi24 from './IconOpenAi24';
import IconOpenAi32 from './IconOpenAi32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconOpenAi = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconOpenAi12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconOpenAi16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconOpenAi20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconOpenAi24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconOpenAi32 {...props} />}
        </span>
    );
};
IconOpenAi.displayName = 'FondueIconOpenAi';

export default memo(IconOpenAi);
